module.exports = __webpack_public_path__ + "img/bell.5aa78b73.png";